module.exports = __webpack_public_path__ + "static/lunchtype22-medium-webfont-8a0611a211b97c5476427ff275e82b88.eot";